import { createEvent } from '@lib/state-engine';
import { IBagApi, IFillWarehouseBagData } from '@@/bags/ts';
import { IWarehouse } from '@@/warehouses/ts';

export const loadAllWarehouses = createEvent();
export const loadWarehouseInfo = createEvent<IWarehouse['id']>();
export const resetWarehouseInfo = createEvent();
export const removeWarehouseById = createEvent<IWarehouse['id']>();
export const removeWarehouseByIdSuccess = createEvent();
export const removeWarehouseByIdError = createEvent();
export const addWarehouseBag = createEvent<IWarehouse['id']>();
export const fillWarehouseBag = createEvent<{
  bagId: IBagApi['id'];
  data: IFillWarehouseBagData;
}>();
export const fillWarehouseBagSuccess = createEvent();
export const clearWarehouseBag = createEvent<{
  warehouseId: IWarehouse['id'];
  bagId: IBagApi['id'];
}>();
export const clearWarehouseBagSuccess = createEvent();
export const clearWarehouseBagError = createEvent<string>();
export const removeWarehouseBag = createEvent<{
  warehouseId: IWarehouse['id'];
  bagId: IBagApi['id'];
}>();
export const removeWarehouseBagSuccess = createEvent();
export const removeWarehouseBagError = createEvent<string>();
